import { useState } from 'react';
import { Dropdown, Button, Modal } from 'react-bootstrap';
import axios from "axios";

function Sposta_la_ditta_nel_cestino(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const cancellazione_ditta = (parametro) => {
//    console.log(input);
    //        axios.post('http://localhost:3001/create', newNote)
    console.log(props)
    axios.patch('/ditte/cancella_ditta/' + props.ditta._id + '/' + parametro)
        .then((res) => {
            console.log(res.data)

        }).catch((error) => {
            console.log(error)
        });
    props.SET_variab_aggiorna(current => !current)
    setShow(false)
    }

  return (
    <>
 
      {props.ditta.cestino == 0 && <Dropdown.Item 
                                     onClick={() => setShow(true)} >Cancella Ditta</Dropdown.Item>}
      {props.ditta.cestino == 1 && <Dropdown.Item 
                                      onClick={() => cancellazione_ditta (0)} >Ripristina Ditta</Dropdown.Item> }
                                       
     

      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Sposta ditta nel cestino</Modal.Title>
        </Modal.Header>
        <Modal.Body>Per recuperare la ditta dovrai contattare gli amministratori dell'applicazione</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annulla
          </Button>
          <Button variant="primary" onClick={() => cancellazione_ditta(1)}>
            Cancella
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Sposta_la_ditta_nel_cestino;